// removed by extract-text-webpack-plugin
module.exports = {"SearchBar":"SearchBar__SearchBar__2hfi2","searchPreview":"SearchBar__searchPreview__JUYST","searchIcon":"SearchBar__searchIcon__3P4-1","SearchBarUserInput":"SearchBar__SearchBarUserInput__2_EDg","searchInput":"SearchBar__searchInput__2cREh","closeIcon":"SearchBar__closeIcon__1fMiZ","inputAppear":"SearchBar__inputAppear__3XT9q","inputAppearActive":"SearchBar__inputAppearActive__27JSf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchBar/SearchBar.scss
// module id = 274
// module chunks = 0